<template>
  <v-card>
    <v-card-text>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12 sm8 md8>
            <v-card class="pa-3">
              <v-layout row>
                <EditClientAddress @update="updateData($event)" />
              </v-layout>
            </v-card>
            <v-card class="mt-2">
              <v-card-text>
                <!-- <terms-and-conditions class="scroll-y"></terms-and-conditions> -->
                <v-flex xs6>
                  <v-subheader class="black--text title"
                    >Terms & Conditions</v-subheader
                  >
                </v-flex>
                <div style="max-height: 300px" class="scroll-y">
                  <terms-and-conditions></terms-and-conditions>
                </div>
                <v-checkbox
                  v-model="terms_and_conditions"
                  label="I agree to this terms and conditions"
                ></v-checkbox>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm4 md4>
            <v-card class="pa-3 ml-4 grey lighten-4">
              <h3 class="headline" align="center">Payment Details</h3>
              <div class="mt-3">
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout row>
                    <v-flex xs8>
                      <v-subheader>Package Name</v-subheader>
                    </v-flex>
                    <v-flex xs4>
                      <p>
                        {{
                          subscriptionPack ? subscriptionPack.package_name : ""
                        }}
                      </p>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs8>
                      <v-subheader>Amount</v-subheader>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        v-model="editedItem.amount"
                        :rules="[(v) => !!v || 'This field is required!']"
                        type="number"
                        disabled
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>
              </div>
            </v-card>
            <v-card class="pa-3 mt-4 ml-4">
              <div>
                <h3 class="headline mb-1">Payment Method</h3>
              </div>
              <div>
                <v-radio-group v-model="column">
                  <v-radio
                    v-for="(radio, n) in radios"
                    :key="n"
                    :label="`${radio.name}`"
                    :value="radio.value"
                  ></v-radio>
                </v-radio-group>
              </div>
              <v-layout row>
                <v-flex xs12>
                  <v-btn
                    color="success"
                    :disabled="!terms_and_conditions"
                    block
                    @click="payNow"
                    >Pay Now</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { EditClientAddress } from "@/components/index";
import { TermsAndConditions } from "@/components/index";
import router from "@/router";
export default {
  components: {
    EditClientAddress,
    TermsAndConditions,
  },
  data() {
    return {
      valid: true,
      dialog: false,
      clicked: false,
      apiUrl: "client-pay",
      subscriptionPack: null,
      editedItem: {
        amount: null,
        gateway_charge: null,
        total_amount: null,
      },
      terms_and_conditions: false,
      column: 1,
      radios: [{ name: "Payment Getway", value: 1 }],
      client: {
        address: null,
      },
      componentKey: 0,
    };
  },

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
  },

  created() {
    this.initialize();
  },

  mounted() {
    this.subscriptionPack = this.$route.params.subscription_pack;
    if (this.subscriptionPack) {
      this.editedItem.amount = (this.subscriptionPack.package_price).replace(/\D/g,'');
      this.subscriptionPack.package_price=this.editedItem.amount;
    }
  },

  methods: {
    initialize() {
      this.$store.dispatch("setIndexData", ["payment.gateway-charge-info"]);
    },
    close() {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    updateData(event) {
      this.client.address = event;
      // console.log(event);
      
    },

    payNow() {
      if (this.client.address == null) {
        alert("Your billing address should not be null");
      }else if(!this.subscriptionPack){
        alert("Subscription info not found");
        var popUpMsg2 = confirm("Do you want to go back subscription page?");
        if (popUpMsg2) {
          router.push('/subscription-package');
        }
      } else {
        if (this.$refs.form.validate()) {
          var popUpMsg = confirm("Are you sure you want to pay?");
          if (popUpMsg) {
            // console.log(this.editedItem);
            // this.$store.dispatch("storePayment", [
            //   "add-money",
            //   this.editedItem,
            // ]);
            this.$store.dispatch("storePayment", [
              "port-wallet-payment",
              this.subscriptionPack,
            ]);
            this.close();
          }
        }
      }
    },
  },
};
</script>

<style>
.flex_border {
  border-color: black !important;
}
</style>
